// extracted by mini-css-extract-plugin
export default {"root":"TableCell_root__M4LV-"};